import React from 'react';
import { Button, Icon, Typography } from '@ann/web-components';
import { useSelectionActionBarFloating } from '../../hooks/useSelectionActionBarFloating';
import {
  SelectionActionBarAnchor,
  SelectionActionBarContainer,
  SelectionActionBarInner,
  SelectionInfo,
  SelectionActions,
  CloseSelectionButton,
} from './SelectionActionBar.styled';

const SelectionActionBar = ({ selectedCount, onArchive, onClearSelection }) => {
  const {
    anchorRef,
    isFloating,
    floatingStyle,
  } = useSelectionActionBarFloating();

  return (
    <>
      <SelectionActionBarAnchor ref={anchorRef} $isFloating={isFloating} />
      <SelectionActionBarContainer
        $isFloating={isFloating}
        style={isFloating ? floatingStyle : undefined}
      >
        <SelectionActionBarInner>
          <SelectionInfo>
            <Typography category="body" size="medium" weight="regular" color="body">
              {selectedCount} {selectedCount === 1 ? 'Note' : 'Notes'} selected
            </Typography>
            <Button
              label="Archive"
              type="tertiary"
              size="small"
              iconLeft="archive"
              onClick={onArchive}
            />
          </SelectionInfo>
          <SelectionActions>
            <CloseSelectionButton
              onClick={onClearSelection}
              title="Clear selection"
              aria-label="Clear selection"
            >
              <Icon name="close" width="18px" height="18px" />
            </CloseSelectionButton>
          </SelectionActions>
        </SelectionActionBarInner>
      </SelectionActionBarContainer>
    </>
  );
};

export default React.memo(SelectionActionBar);
